import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { useSchedulingSelector } from '../../../../state/SplitTests/selectors/useSchedulingSelector';
import { useCallback } from 'react';

export const useStartTime = ({ splitTestId }: { splitTestId: string }) => {
  const { dispatch } = useCampaignEditorContext();

  const { startTime } = useSchedulingSelector({ splitTestId }) ?? {};
  const onStartTimeChanged = useCallback(
    (startTime: string) => dispatch({ type: 'SET_START_TIME', payload: { id: splitTestId, startTime } }),
    [dispatch, splitTestId],
  );

  return {
    startTime,
    onStartTimeChanged,
  };
};
